import { CustomerSatisfactionTemplate } from "../../Templates/CustomerSatisfactionTemplate";

export const CustomerSatisfaction = () => {
  return <CustomerSatisfactionTemplate />;
};
